import { encodeBase64Url, randomBase64Url, sha256 } from './base64url';

/**
 * PKCE (RFC 7636) no navegador.
 *
 * O contrato do IDP exige Authorization Code + PKCE S256 sem excecao, inclusive
 * para SPA (`seazone-idp/docs/integracao/proibicoes.md`, item 4). O client
 * `sapron-frontend` e publico: nao existe segredo no navegador, e e o
 * `code_verifier` que prova que quem troca o code e quem comecou o login.
 */

/** 32 bytes em base64url dao 43 caracteres, o minimo que o RFC aceita. */
const RANDOM_BYTES = 32;

export function createCodeVerifier(): string {
  return randomBase64Url(RANDOM_BYTES);
}

export function createState(): string {
  return randomBase64Url(RANDOM_BYTES);
}

/**
 * `nonce` do OIDC. Amarra o `id_token` devolvido a tentativa de login que o
 * pediu, o que o `state` nao faz: `state` protege a rota de callback, `nonce`
 * protege o token.
 */
export function createNonce(): string {
  return randomBase64Url(RANDOM_BYTES);
}

/** `code_challenge` no metodo S256, o unico que o contrato aceita. */
export async function challengeFrom(codeVerifier: string): Promise<string> {
  return encodeBase64Url(await sha256(codeVerifier));
}
